import { createObservableDataAction, IAction, IActionInput, IActionContext, sendRequest, CacheType } from '@msdyn365-commerce/core';

/**
 * Simple Form Input Action
 */
export class SimpleFormInput implements IActionInput {

    /**
     * The user's form data
     */
    public formData: {};

    /**
     * The form service endpoint
     */
    public serviceEndpoint: string;

    constructor(
        formData: {},
        serviceEndpoint: string
    ) {
        this.formData = formData;
        this.serviceEndpoint = serviceEndpoint;
    }

    public getCacheKey = () => 'SimpleForm';
    public getCacheObjectType = () => 'SimpleForm';
    public dataCacheType = (): CacheType => 'none';
}

/**
 * This data action allows submitting the form to the service
 */
async function submitSimpleForm(input: SimpleFormInput, ctx: IActionContext): Promise<string> {
    return sendRequest<string>(input.serviceEndpoint, 'post', input.formData).then((response) => {
        if (response.status !== 200 && response.status !== 201) {
            throw new Error('[simpleFormAction] Form failed to submit');
        }
        return 'success';
    }).catch(() => {
        throw new Error('[simpleFormAction] Form failed to submit');
    });
}

export const SimpleFormDataAction = createObservableDataAction({
    action: <IAction<string>>submitSimpleForm
});

export default SimpleFormDataAction;
